module.exports = __webpack_public_path__ + "static/media/postgres.03c4e1f6.png";